module.exports = __webpack_public_path__ + "static/media/face3.6e8db10e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/FeedbackForm/images/face3.svg
// module id = 1223
// module chunks = 2